import { render, staticRenderFns } from "./ui-project-type-select.vue?vue&type=template&id=a62e2e60&"
import script from "./ui-project-type-select.vue?vue&type=script&lang=js&"
export * from "./ui-project-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports